module.exports = __webpack_public_path__ + "static/media/lock-feature-02.63126f8b.png";